import { render, staticRenderFns } from "./RulesDialog.vue?vue&type=template&id=0307e1b1&"
import script from "./RulesDialog.vue?vue&type=script&lang=js&"
export * from "./RulesDialog.vue?vue&type=script&lang=js&"
import style0 from "./RulesDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports